module.exports = __webpack_public_path__ + "static/media/kde-neon.d175112b.png";